import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, UsersRound, Briefcase } from 'lucide-react';
import { services } from '../mock';

const iconMap = {
  'shield-check': ShieldCheck,
  'users-round': UsersRound,
  'briefcase': Briefcase,
};

const Services = () => {
  return (
    <section id="servicos" className="py-24 px-6 bg-[#f5f5f3]">
      <div className="max-w-[1300px] mx-auto">
        <div className="text-center mb-16">
          <p
            className="text-[#C99A36] tracking-[0.4em] text-[12px] font-semibold mb-4"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            SERVIÇOS
          </p>
          <h2
            className="text-[#1a1a1a] text-[36px] md:text-[44px] font-bold tracking-tight"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Serviços
          </h2>
          <div className="mx-auto mt-4 w-24 h-[3px] bg-[#C99A36]" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {services.map((s) => {
            const Icon = iconMap[s.icon];
            return (
              <Link
                key={s.id}
                to={`/servicos/${s.slug}`}
                className="group relative overflow-hidden rounded-sm shadow-sm hover:shadow-2xl transition-shadow duration-500 cursor-pointer block"
                style={{ minHeight: 520 }}
              >
                <div
                  className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110"
                  style={{ backgroundImage: `url(${s.image})` }}
                />
                <div className="absolute inset-0 bg-gradient-to-b from-[#C99A36]/85 via-[#8a6716]/85 to-[#3a2a10]/90" />

                <div className="relative z-10 h-full flex flex-col items-center text-center px-8 py-12">
                  <div className="mb-6 p-4 rounded-full border border-white/40 group-hover:border-white transition-colors">
                    <Icon size={48} className="text-white" strokeWidth={1.3} />
                  </div>
                  <h3
                    className="text-white text-[20px] md:text-[22px] font-bold tracking-[0.12em] mb-6 uppercase"
                    style={{ fontFamily: "'Montserrat', sans-serif" }}
                  >
                    {s.title}
                  </h3>
                  <p
                    className="text-white/95 text-[14px] leading-[1.85] tracking-wide"
                    style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
                  >
                    {s.description}
                  </p>
                  <span className="mt-auto pt-8">
                    <span className="inline-block px-6 py-2 bg-[#1a1a1a] text-white text-[12px] tracking-[0.25em] font-semibold group-hover:bg-white group-hover:text-[#1a1a1a] transition-colors duration-300">
                      SERVIÇOS
                    </span>
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
